import axios from 'axios';

export const WatsonsBranchService = {
  getWatsonsCities() {
    return axios.get(`${process.env.VUE_APP_API}/partners/watsons/cities`);
  },
  getWatsonsBranch(cityname = '') {
    return axios.get(`${process.env.VUE_APP_API}/partners/watsons/branches`, {
      params: {
        coverage: cityname
      }
    });
  },
};
